module.exports = __webpack_public_path__ + "static/img/depart_icon.7640ced3.png";